import React from 'react';

interface ComponentProps {
  count?: number;
}

const Space: React.FC<ComponentProps> = ({ count = 1 }) => <>{'\u00A0'.repeat(count)}</>;

export default Space;
